<!-- New Tailwind-based Admin Layout -->
<div class="flex bg-brand-bg"
     [class.min-h-screen]="!isContentFillMode"
     [class.h-screen]="isContentFillMode"
     [class.overflow-hidden]="isContentFillMode">

  <!-- Sidebar Navigation -->
  <aside class="fixed inset-y-0 left-0 z-50 w-64 bg-brand-navy transform transition-transform duration-300 lg:translate-x-0 flex flex-col"
         [class.translate-x-0]="sidebarVisible"
         [class.-translate-x-full]="!sidebarVisible">

    <!-- Logo Area (fixed height) -->
    <div class="h-16 flex-shrink-0 flex items-center justify-center bg-brand-navy-dark border-b border-white/10">
      <img src="/assets/images/logo.png" alt="ParseEasy Admin" class="h-9 object-contain">
    </div>

    <!-- Navigation (scrollable) -->
    <nav #sideNav class="flex-1 overflow-y-auto scrollbar-hide py-4" (scroll)="$event.stopPropagation()">
      <div *ngFor="let section of navSections; trackBy: trackNavSection" class="mb-6">
        <h3 *ngIf="section.title" class="px-5 mb-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
          {{ section.title }}
        </h3>
        <div class="flex flex-col gap-1.5 px-2">
        <a *ngFor="let item of section.items; trackBy: trackNavItem"
           [routerLink]="item.route"
           [class.nav-active]="isNavActive(item.route)"
           class="admin-nav-link flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/5 transition-colors cursor-pointer">
          <svg class="w-[18px] h-[18px] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <ng-container [ngSwitch]="item.icon">
              <ng-container *ngSwitchCase="'dashboard'">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </ng-container>
              <ng-container *ngSwitchCase="'business'">
                <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'admin_panel_settings'">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'people'">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 00-3-3.87"></path>
                <path d="M16 3.13a4 4 0 010 7.75"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'analytics'">
                <line x1="12" y1="20" x2="12" y2="10"></line>
                <line x1="18" y1="20" x2="18" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="16"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'payments'">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                <line x1="1" y1="10" x2="23" y2="10"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'account_balance_wallet'">
                <path d="M21 12V7H5a2 2 0 010-4h14v4"></path>
                <path d="M3 5v14a2 2 0 002 2h16v-5"></path>
                <circle cx="18" cy="16" r="1"></circle>
              </ng-container>
              <ng-container *ngSwitchCase="'description'">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'pending_actions'">
                <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"></path>
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
              </ng-container>
              <ng-container *ngSwitchCase="'psychology'">
                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                <rect x="9" y="9" width="6" height="6"></rect>
                <line x1="9" y1="1" x2="9" y2="4"></line>
                <line x1="15" y1="1" x2="15" y2="4"></line>
                <line x1="9" y1="20" x2="9" y2="23"></line>
                <line x1="15" y1="20" x2="15" y2="23"></line>
                <line x1="20" y1="9" x2="23" y2="9"></line>
                <line x1="20" y1="15" x2="23" y2="15"></line>
                <line x1="1" y1="9" x2="4" y2="9"></line>
                <line x1="1" y1="15" x2="4" y2="15"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'settings'">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'flag'">
                <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                <line x1="4" y1="22" x2="4" y2="15"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'monitor_heart'">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'memory'">
                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                <rect x="9" y="9" width="6" height="6"></rect>
                <line x1="9" y1="1" x2="9" y2="4"></line>
                <line x1="15" y1="1" x2="15" y2="4"></line>
                <line x1="9" y1="20" x2="9" y2="23"></line>
                <line x1="15" y1="20" x2="15" y2="23"></line>
                <line x1="20" y1="9" x2="23" y2="9"></line>
                <line x1="20" y1="15" x2="23" y2="15"></line>
                <line x1="1" y1="9" x2="4" y2="9"></line>
                <line x1="1" y1="15" x2="4" y2="15"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'edit_note'">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'rule'">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'insights'">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                <polyline points="17 6 23 6 23 12"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'support_agent'">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'groups'">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 00-3-3.87"></path>
                <path d="M16 3.13a4 4 0 010 7.75"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'person_search'">
                <circle cx="10" cy="8" r="3"></circle>
                <path d="M4 20v-1a5 5 0 015-5h2"></path>
                <circle cx="17" cy="17" r="3"></circle>
                <line x1="19.2" y1="19.2" x2="21" y2="21"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'history'">
                <polyline points="1 4 1 10 7 10"></polyline>
                <path d="M3.51 15a9 9 0 102.13-9.36L1 10"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'assessment'">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'security'">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0110 0v4"></path>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <circle cx="12" cy="12" r="9"></circle>
              </ng-container>
            </ng-container>
          </svg>
          <span class="text-sm font-medium">{{ item.label }}</span>
        </a>
        </div>
      </div>

    </nav>
  </aside>

  <!-- Sidebar Overlay (Mobile) -->
  <div class="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
       [class.opacity-100]="sidebarVisible"
       [class.opacity-0]="!sidebarVisible"
       [class.pointer-events-none]="!sidebarVisible"
       (click)="toggleSidebar()">
  </div>

  <!-- Main Content Area -->
  <main class="flex-1 lg:ml-64 flex flex-col"
        [class.min-h-screen]="!isContentFillMode"
        [class.h-screen]="isContentFillMode"
        [class.min-h-0]="isContentFillMode">

    <!-- Header -->
    <header class="sticky top-0 z-30 pe-app-header flex shrink-0 items-center justify-between px-4 lg:px-6">

      <!-- Left: page title -->
      <div class="flex items-center gap-4 min-w-0 flex-1">
        <div *ngIf="pageHeader$ | async as header" class="pe-app-header-heading flex min-w-0 items-center">
          <div class="pe-app-header-heading__icon" aria-hidden="true">
            <app-page-header-icon [icon]="header.icon"></app-page-header-icon>
          </div>
          <div class="pe-app-header-heading__text min-w-0">
            <h1 class="pe-app-header-heading__title">{{ header.title }}</h1>
            <p *ngIf="header.subtitle" class="pe-app-header-heading__subtitle">{{ header.subtitle }}</p>
          </div>
        </div>

        <!-- Super Admin / Platform chip (hidden)
        <div class="flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-200">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-blue to-brand-navy flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
            </svg>
          </div>
          <div class="hidden sm:block text-left">
            <div class="text-sm font-semibold text-slate-800">Super Admin</div>
            <div class="text-xs text-slate-500">Platform</div>
          </div>
        </div>
        -->
      </div>

      <div class="pe-app-header__actions">
        <button type="button" (click)="navigateToNotifications()"
                class="pe-icon-btn pe-icon-btn--ghost pe-notify-btn" aria-label="Notifications">
          <svg class="w-[1.125rem] h-[1.125rem]" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
          </svg>
          <span *ngIf="notificationCount > 0" class="pe-notify-btn__badge" aria-hidden="true">
            {{ notificationCount > 9 ? '9+' : notificationCount }}
          </span>
        </button>

        <div class="relative user-menu">
          <div *ngIf="userDropdownVisible" (click)="closeUserDropdown()" class="fixed inset-0 z-40"></div>
          <button
            type="button"
            (click)="toggleUserDropdown()"
            class="pe-user-chip pe-user-chip--portal-role pe-user-chip--with-meta"
            aria-haspopup="menu"
            [attr.aria-expanded]="userDropdownVisible"
            [attr.aria-label]="'Account menu for ' + userName">
            <span class="pe-user-chip__avatar pe-user-chip__avatar--sm" aria-hidden="true">{{ userInitials }}</span>
            <span class="pe-user-chip__meta pe-user-chip__meta--header">
              <span class="pe-user-chip__name">{{ userName }}</span>
              <span class="pe-user-chip__email" *ngIf="userEmail">{{ userEmail }}</span>
            </span>
            <svg class="pe-user-chip__chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          <!-- User Dropdown -->
          <div *ngIf="userDropdownVisible"
               class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-slate-200 py-2 z-50 animate-fade-in">
            <!-- Menu Items -->
            <a (click)="navigateToProfile()"
               class="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer transition-colors">
              <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
              My Profile
            </a>
            <a routerLink="/super-admin/notifications" (click)="closeUserDropdown()"
               class="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer transition-colors">
              <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
              </svg>
              Notifications
            </a>

            <!-- Logout -->
            <div class="border-t border-slate-100 pt-1 mt-1">
              <a (click)="logout(); closeUserDropdown()"
                 class="flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 cursor-pointer transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                </svg>
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!--
      Layout contract (authenticated shell):
      - Full-width content (no max-w / mx-auto gutters). Modest p-4 padding only.
      - Page title: app-page-header as the first content landmark; optional backHref / [page-header-back].
      - Scroll: default overflow-y-auto on this pane. Fill routes use layout-content--fill
        (flex-1 min-h-0 overflow-hidden flex flex-col) so the child owns inner scroll.
    -->
    <div class="flex-1 w-full p-4 bg-brand-bg"
         [class.overflow-y-auto]="!isContentFillMode"
         [class.layout-content--fill]="isContentFillMode"
         [class.min-h-0]="isContentFillMode"
         [class.overflow-hidden]="isContentFillMode"
         [class.flex]="isContentFillMode"
         [class.flex-col]="isContentFillMode">
      <div class="w-full"
           [class.layout-content-inner--fill]="isContentFillMode"
           [class.flex-1]="isContentFillMode"
           [class.min-h-0]="isContentFillMode"
           [class.flex]="isContentFillMode"
           [class.flex-col]="isContentFillMode">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
